// extracted by mini-css-extract-plugin
export default {"addToCartControl":"V2-z","giftCard":"W2-z","btnContainer":"X2-z","cartButton":"Y2-z","disabled":"Z2-z"};